import React from 'react';
import P, { InferProps } from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import SceneConfig from './scene-config';

function SceneConfigRoute({ match }: InferProps<typeof SceneConfigRoute.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:id`} component={SceneConfig} />
    </Switch>
  );
}

SceneConfigRoute.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default SceneConfigRoute;
